import { defineMessages } from "react-intl";
const messages = defineMessages({
    requestHistoryTooltipText: {
        id: "app.scanRequests.table.requestHistory.tooltip",
        defaultMessage: "Request History",
    },
    requestedAtMessage: {
        id: "app.scanRequests.table.requestHistory.requestedAt.message",
        defaultMessage: "Scan <bold>request submitted</bold> by {requesterName}",
    },
    skippedAtMessage: {
        id: "app.scanRequests.table.requestHistory.skippedAt.message",
        defaultMessage: "{skippedByName} <bold>skipped</bold> this space {reason}",
    },
    becauseText: {
        id: "app.scanRequests.table.requestHistory.becauseText",
        defaultMessage: "because",
    },
    canceledAtMessage: {
        id: "app.scanRequests.table.requestHistory.canceledBy.message",
        defaultMessage: "Photoshoot was <bold>canceled</bold> by {canceledByName} {reason}",
    },
    scheduledAtMessage: {
        id: "app.scanRequests.table.requestHistory.scheduledAt.message",
        defaultMessage: "Photoshoot was <bold>scheduled</bold> for {date}",
    },
    completedAtMessage: {
        id: "app.scanRequests.table.requestHistory.completedAt.message",
        defaultMessage: "Scan was <bold>completed</bold>",
    },
    uploadedAtMessage: {
        id: "app.scanRequests.table.requestHistory.uploadedAt.message",
        defaultMessage: "Scan was successfully <bold>uploaded</bold> at {date}",
    },
    noHistoryAvailable: {
        id: "app.scanRequests.table.requestHistory.noHistoryAvailable",
        defaultMessage: "No history available",
    },
});
export default messages;
